export default {
  list: [],
  next_url: null,
  total: 0
};
